<div id="content">
  <div class="page-title conciliation-header">
    <div>
      <h1>{{ page_title }}</h1>
      @if (company_product_id() === null) {
        <p class="subtitle">Selecciona un producto desde el listado para conciliar facturas.</p>
      }
    </div>
    <div class="header-toolbar">
      <a mat-stroked-button class="back-button" [routerLink]="list_back_link()" [queryParams]="back_query_params()">
        <mat-icon>arrow_back</mat-icon>
        {{ back_button_label() }}
      </a>
    </div>
  </div>

  @if (company_product_id() === null) {
    <p>Usa el listado de facturas de productos y pulsa «Conciliar» en un periodo.</p>
  } @else {
    <div class="conciliation-layout">
      <section class="conciliation-column">
        <h2>Facturas pendientes</h2>
        @if (is_loading()) {
          <p>Cargando facturas...</p>
        } @else if (invoices().length === 0) {
          <p>No hay facturas pendientes de conciliar para este producto.</p>
        } @else {
          <mat-accordion>
            @for (invoice of invoices(); track invoice.id) {
              <mat-expansion-panel
                class="invoice-expansion-panel"
                [expanded]="selected_invoice_id() === invoice.id"
                (opened)="selectInvoice(invoice)"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="invoice-panel-header-content">
                      <div class="invoice-panel-identity">
                        <span class="invoice-panel-number">{{ invoice.invoice_number }}</span>
                        <span class="invoice-panel-date-chip">{{ invoice.invoice_date | date: 'dd/MM/yyyy' }}</span>
                      </div>
                      <mat-progress-bar
                        class="invoice-panel-progress"
                        mode="determinate"
                        [value]="invoice.conciliation_progress"
                        [matTooltip]="invoice.conciliation_progress_tooltip"
                      ></mat-progress-bar>
                      <span class="invoice-panel-pending"> Pendiente: {{ invoice.hours_pending_conciliation_label }} </span>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                @if (invoice.other_period_conciliations.length > 0) {
                  <div class="existing-conciliations">
                    <h3>Conciliaciones en otros periodos</h3>
                    <ul class="existing-conciliations-list">
                      @for (conciliation of invoice.other_period_conciliations; track conciliation.id) {
                        <li>
                          <span class="existing-conciliation-period">{{ conciliation.period_label }}</span>
                          <span class="existing-conciliation-amount">
                            {{ conciliation.hours_conciliated_label }} · {{ conciliation.amount_conciliated_label }}
                          </span>
                          @if (conciliation.is_automatic) {
                            <span class="existing-conciliation-origin">Automática</span>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                }

                <div class="invoice-lines">
                  @for (line of invoice.invoice_lines; track line.id) {
                    <label class="invoice-line-row" [class.invoice-line-row-disabled]="line.conciliations_count > 0">
                      <mat-checkbox
                        [checked]="isLineSelected(line.id)"
                        [disabled]="line.conciliations_count > 0"
                        (change)="toggleInvoiceLine(line.id, line, $event.checked)"
                      ></mat-checkbox>
                      <span class="line-concept">
                        {{ line.concept }}
                        @if (line.description) {
                          <span class="line-description"> — {{ line.description }}</span>
                        }
                        @if (line.conciliations_count > 0) {
                          <span class="line-conciliations-count" [matTooltip]="line.conciliations_tooltip ?? ''">
                            {{ line.conciliations_count }}
                          </span>
                        }
                      </span>
                      <span class="line-quantity">{{ line.quantity }}h</span>
                      <span class="line-amount">{{ line.amount | currency: 'EUR' }}</span>
                    </label>
                  }
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        }
      </section>

      <section class="conciliation-column">
        <h2>Periodos del producto</h2>
        <table mat-table [dataSource]="periods_data_source()">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row; dataSource: periods_data_source()">
              <mat-radio-button
                name="conciliation_period"
                [checked]="selected_period_id() === row.id"
                (change)="selectPeriod(row)"
                (click)="$event.stopPropagation()"
              ></mat-radio-button>
            </td>
          </ng-container>
          <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef>Mes</th>
            <td mat-cell *matCellDef="let row; dataSource: periods_data_source()">{{ row.month_label }}</td>
          </ng-container>
          <ng-container matColumnDef="hours">
            <th mat-header-cell *matHeaderCellDef>Conc. / Reg.</th>
            <td mat-cell *matCellDef="let row; dataSource: periods_data_source()">
              <div class="period-hours-cell">
                @if (!row.is_current_month) {
                  <mat-progress-bar
                    class="period-hours-progress"
                    mode="determinate"
                    [value]="row.hours_progress"
                    [matTooltip]="row.hours_progress_tooltip"
                  ></mat-progress-bar>
                }
                <span class="period-hours-label">{{ row.hours_summary_label }}</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="billing_status">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let row; dataSource: periods_data_source()">
              <span [class]="'status-' + row.billing_status_color">{{ row.billing_status_label }}</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayed_period_columns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayed_period_columns" [class.selected-row]="row.is_selected"></tr>
        </table>

        <form class="conciliation-form" [formGroup]="conciliation_form">
          <mat-form-field appearance="outline" class="full-width-field nobottom">
            <mat-label>Comentario</mat-label>
            <input matInput type="text" formControlName="comment" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="nobottom">
            <mat-label>Horas a conciliar</mat-label>
            <input matInput type="number" step="0.01" formControlName="hours_conciliated" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="nobottom">
            <mat-label>Importe a conciliar (€)</mat-label>
            <input matInput type="number" step="0.01" formControlName="amount_conciliated" />
          </mat-form-field>
          <button
            mat-flat-button
            color="accent"
            type="button"
            class="submit-button"
            [disabled]="!can_submit()"
            (click)="submitConciliation()"
          >
            <mat-icon>check_circle</mat-icon>
            Conciliar
          </button>
        </form>
      </section>
    </div>
  }
</div>
